import React from 'react';
import { useTranslation } from 'react-i18next';
import { openCookiePreferences } from '@/components/consent/openCookiePreferences';
import { consentCopy, getPrivacyPolicyUrl, getRefundPolicyUrl, getTermsUrl, marketingLinkProps } from '@/lib/consent';
import './auth-legal-footer.css';

function AuthLegalFooter(): React.ReactElement {
  const { t } = useTranslation('common');
  const privacyUrl = getPrivacyPolicyUrl();
  const termsUrl = getTermsUrl();
  const refundUrl = getRefundPolicyUrl();

  return (
    <nav className="auth-legal-footer" aria-label={t('legal')}>
      <a {...marketingLinkProps(privacyUrl)}>{consentCopy.privacyPolicy}</a>
      <span aria-hidden="true">·</span>
      <a {...marketingLinkProps(termsUrl)}>{consentCopy.terms}</a>
      <span aria-hidden="true">·</span>
      <a {...marketingLinkProps(refundUrl)}>{consentCopy.refundPolicy}</a>
      <span aria-hidden="true">·</span>
      <button type="button" className="auth-legal-footer__button" onClick={openCookiePreferences}>
        {consentCopy.cookiePreferencesLink}
      </button>
    </nav>
  );
}

export default AuthLegalFooter;
